<template>
  <v-list-item
    class="px-0"
    dense
    :two-line="!!subtitle"
  >
    <v-list-item-avatar>
      <div class="text-left">
        <v-icon v-html="`${icon}`" />
      </div>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title
        class="overline"
        v-text="title"
      />
      <v-list-item-subtitle
        class="overline"
        v-if="!!subtitle"
        v-text="subtitle"
      />
    </v-list-item-content>
    <v-list-item-action v-if="actions">
      <slot />
    </v-list-item-action>
  </v-list-item>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: ''
    },
    actions: {
      type: Boolean,
      default: false
    }
  }
}
</script>
